export default "__VITE_ASSET__d3509a5c__"